<template>
  <div>
    <el-dialog :visible.sync="open" class="my_dia" @close="handleClose">
      <div class="dia_header">
        <p v-bind:class="{ on: active === 'delegate' }" @click="tabCliack('delegate')">Stake</p>
        <p v-bind:class="{ on: active === 'undelegate' }" @click="tabCliack('undelegate')">Unstake</p>
      </div>
      <div class="stakeDes" v-if="active === 'delegate'">
        <div class="img">
          <img src="@/assets/image/stake/icon2.png" alt="" width="100%">
        </div>
        When you unstake, the staked UNIT will be transferred to your account after 21 days, and the rewards will arrive
        shortly thereafter.
      </div>
      <el-form :model="stakeForm" :label-width="isMobile ? '0' : '150px'" ref="stakeForm" :rules="rules" class="stake-form">
        <el-form-item label="Validator：">
          <div class="userinfo" v-if="userInfo.moniker">
            <div class="img">
              <img v-if="userInfo.pictures" :src="userInfo.pictures" alt=""/>
              <img v-else src="@/assets/image/stake/icon.png" alt=""/>
            </div>
            <span class="name">{{ userInfo.moniker }}</span>
            <span class="web" v-if="userInfo.website" @click="handleOpen(userInfo.website)">Website</span>
          </div>
          {{ stakeForm.operator_address }}
        </el-form-item>
        <el-form-item label="My Staked：">
          <big-number :number="stakeForm.staked" class="num"/>
          <span class="td-word-sm">UNIT</span>
        </el-form-item>
        <el-form-item label="Wallet Blance：" v-if="active === 'delegate'">
          <big-number :number="stakeForm.blance" class="num"/>
          <span class="td-word-sm">UNIT</span>
        </el-form-item>
        <el-form-item :label="`${amountLabel}：`" prop="amount">
          <el-input v-model="stakeForm.amount" :style="{width: isMobile ? '100%' : '3.5rem'}" class="amount-input">
            <template slot="suffix">UNIT</template>
          </el-input>
          <span class="maxbtn" @click="handleMax" v-if="active === 'undelegate' && stakeForm.staked > 0">MAX</span>

        </el-form-item>
        <!-- <el-form-item>
          <span style="color:#D92E2F;" v-show="maxFlag"></span>
        </el-form-item> -->

      </el-form>
      <div class="btn_box">
        <!--  -->
        <el-button class="btn" @click="handleSubmit" :disabled="btnFlag">Submit</el-button>

      </div>
      <div class="tips" v-if="active === 'delegate' && stakeForm.staked > 0">
        <p>Tips:</p>
        <p>You have already staked the Validator. If you continue to stake, the rewards will be recalculated and the
          rewards you have already earned will be sent to your account.</p>
      </div>
      <div class="tips" v-if="active === 'undelegate' && stakeForm.staked > 0">
        <p>Tips:</p>
        <p>After unstaking, the staked UNIT will be sent to your account after 21 days, and the rewards will arrive
          shortly thereafter.</p>
      </div>

    </el-dialog>

    <handle ref="handleCom" @success="handleSuccess"></handle>
  </div>

</template>

<script>
import {getShares, getBalances, getUserInfo} from "@/api/stake/stake.js"
import {changeAddress} from "@/api/stake/base.js"
import handle from "@/views/stake/handle/index"
import {toBigNum, toBigItem, toSmallNum, toSmallNumStr2, toSmallNumStr} from "@/utils/bigNumberTran.js";

export default {
  components: {
    handle
  },
  computed: {
    amountLabel() {
      return this.active === 'delegate' ? 'Stake Amount' : 'Unstake Amount'
    },
    btnFlag() {
      return this.active === 'undelegate' && Number(this.stakeForm.staked) <= 0
    },
    isMobile() {
      return window.innerWidth <= 800
    }
  },
  data() {
    var checkAmount = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(`${this.amountLabel} cannot be empty`));
      }
      let reg = /^(?=.*[1-9])\d{0,17}(?:\.\d{1,18})?$/
      // let reg = /^\d+(\.{0,18}\d){0,1}$/
      // let reg = /^(?!0+(?:\.0+)?$)(?:[1-9]\d{0,2}(?:,\d{3})+|\d{1,3})(?:\.\d{0,18})?$/
      // let reg = /^\d+(\.\d{1,18})?$/
      if (!reg.test(value) || value <= 0) {
        return callback(new Error(`The format of the input content is incorrect`));
      }
      if (this.active === 'delegate') {
        if (toBigItem(value).gt(this.stakeForm.blance)) {
          callback(new Error(`${this.amountLabel} cannot be greater than Blance`));
        } else {
          callback();
        }
      } else {
        if (toBigItem(value).gt(this.stakeForm.staked)) {
          callback(new Error(`${this.amountLabel} cannot be greater than Staked`));
        } else {
          callback();
        }
      }
    };
    return {
      active: 'delegate',
      open: false,
      userAddress: undefined,
      userInfo: {},
      stakeForm: {
        operator_address: undefined,
        staked: undefined,
        blance: undefined,
        amount: undefined,
      },
      rules: {
        amount: [
          {validator: checkAmount, trigger: 'blur'}
        ],
      },
      maxFlag: false,
    }
  },
  methods: {
    show(row, type) {
      console.log(row)
      this.active = type || 'delegate'
      this.stakeForm.operator_address = row.operator_address || row.validator_address
      this.stakeForm.amount = undefined
      // this.getUserInfo(row)
      this.userInfo = row.description
      this.getUserAddress().then(() => {
        this.getShares()
        this.getBalances()
        this.open = true
      })
    },
    handleOpen(url) {
      window.open(url, '_blank')
    },
    getUserInfo(row) {
      if (row.description && row.description.identity) {
        getUserInfo(row.description.identity).then(res => {
          if (res.them && res.them.length > 0) {
            this.userInfo.username = res.them[0].basics.username
            this.userInfo.pictures = res.them[0].pictures.primary.url
          } else {
            this.userInfo.username = '';
            this.userInfo.pictures = '';
          }
        })
      } else {
        this.userInfo = {
          username: '',
          pictures: '',
          website: '',
        }
      }
    },
    getShares() {
      getShares(this.stakeForm.operator_address, this.userAddress).then(res => {
        this.stakeForm.staked = res.delegation_response.balance.amount
      }).catch(err => {
        this.stakeForm.staked = 0
      })
      // this.stakeForm.staked = '3438999999999999999999.0000000000000000000'
      // this.stakeForm.staked = '100000000000.0000000000000000000'

    },
    getBalances() {
      getBalances(this.userAddress).then(res => {
        this.stakeForm.blance = (res.balances[0] && res.balances[0].amount) || 0
      })
    },
    getUserAddress() {
      return new Promise((resolve, reject) => {
        changeAddress({
          account: this.$store.getters.metaMaskObj.account
        }).then(res => {
          this.userAddress = res.result.cosmosAccount
          resolve()
        }).catch(err => {
          reject()
        })
      })
    },
    tabCliack(type) {
      this.maxFlag = false
      this.active = type
      this.stakeForm.amount = undefined
      this.$refs.stakeForm.resetFields()
    },
    handleMax() {
      let val = this.active === 'delegate' ? this.stakeForm.blance : this.stakeForm.staked
      console.log(toSmallNumStr2(val))
      console.log(toSmallNumStr(val))
      console.log(toSmallNum(val))
      this.stakeForm.amount = toSmallNumStr2(val)
      this.maxFlag = true
      this.$refs.stakeForm.validateField('amount');
    },
    handleSubmit() {
      this.$refs.stakeForm.validate((valid) => {
        if (valid) {
          this.$refs.handleCom.handle({
            account: this.$store.getters.metaMaskObj.account,
            validatorAddress: this.stakeForm.operator_address,
            type: this.active,
            amount: toBigNum(this.stakeForm.amount)
          })
        }
      });
    },
    handleClose() {
      this.$refs.stakeForm.resetFields()
      this.open = false
    },
    handleSuccess() {
      let val = this.active === 'delegate' ? 'Staked' : 'Unstaked'
      this.$message.success(`${val} successfully!`)
      this.handleClose();
      setTimeout(() => {
        this.$emit('success');
      }, 5000);
    },


  }

}
</script>

<style lang="scss" scoped>
.userinfo {
  display: flex;
  gap: 0.1rem;
  margin-top: 0.05rem;

  .img {
    width: 0.28rem;
    height: 0.28rem;
    border-radius: 50%;
    overflow: hidden;

    img {
      width: 100%;
    }
  }

  .name {
    font-size: 0.2rem;
    font-family: DMSans-Medium, DMSans;
    font-weight: 500;
    color: #1F1F1F;
    line-height: 0.28rem;
  }

  .web {
    width: 0.9rem;
    height: 0.28rem;
    border-radius: 0.17rem;
    font-size: 0.14rem;
    font-family: DMSans-Regular, DMSans;
    font-weight: 400;
    color: #929DAD;
    line-height: 0.28rem;
    background: url('~@/assets/image/stake/web.png') no-repeat 0.08rem center #EFEFEF;;
    padding-left: 0.28rem;
    cursor: pointer;
  }
}

.stakeDes {
  width: 88%;
  font-size: 0.17rem;
  font-family: PlusJakartaDisplay-Medium, PlusJakartaDisplay;
  font-weight: 500;
  color: #1F1F1F;
  line-height: 0.22rem;
  margin-left: 0.4rem;
  margin-bottom: 0.4rem;
  display: flex;

  .img {
    width: 0.56rem;
    margin-right: 0.12rem;
  }
}

.num {
  font-size: 0.2rem;
  font-family: Roboto-Regular, Roboto;
  font-weight: 400;
  color: #1F1F1F;
}

.td-word-sm {
  font-size: 0.18rem;
  font-family: Roboto-Regular, Roboto;
  font-weight: 400;
  color: #929DAD;
}

.my_dia /deep/ .el-dialog {
  min-width: 720px;
  width: 7.2rem !important;
}

.dia_header {
  height: 0.64rem;
  display: flex;
  position: absolute;
  left: 0;
  top: 0;

  p {
    width: 1.7rem;
    font-size: 0.28rem;
    font-family: Roboto-Medium, Roboto;
    font-weight: 500;
    color: #929DAD;
    line-height: 0.62rem;
    margin: 0;
    text-align: center;
    cursor: pointer;
  }

  p.on {
    color: #1F1F1F;
    border-bottom: 0.02rem solid;
    border-image: linear-gradient(44deg, #38F4BA 0%, #31C1D0 100%) 1;
  }
}

.btn_box {
  text-align: center;
  margin-top: 1.24rem;

  .btn {
    width: 5.6rem;
    height: 0.72rem;
    background: linear-gradient(264deg, #225BFC 0%, #062567 100%);
    font-size: 0.24rem;
    font-family: Roboto-Medium, Roboto;
    font-weight: 500;
    color: #FFFFFF;
    // cursor: pointer;
  }
}

.tips {
  // display: flex;
  font-family: Roboto-Regular, Roboto;
  font-weight: 400;
  color: #929DAD;
  line-height: 0.28rem;
  overflow: hidden;

  p:first-child {
    float: left;

  }
}

.maxbtn {
  font-size: 0.2rem;
  cursor: pointer;
  margin-left: 0.1rem;
  color: #225BFC;
}

@media screen and (max-width: 800px) {
  // 对话框适配
  .my_dia {
    /deep/ .el-dialog {
      min-width: 95% !important;
      width: 95% !important;
      max-width: 95% !important;
      margin: 2vh auto !important;
      border-radius: 0.16rem !important;
    }
    
    /deep/ .el-dialog__header {
      padding: 0.2rem 0.2rem 0 !important;
      padding-top: 0.6rem !important;
    }
    
    /deep/ .el-dialog__body {
      padding: 0.24rem 0.2rem 0.2rem !important;
      max-height: calc(100vh - 1.2rem);
      overflow-y: auto;
    }
    
    /deep/ .el-dialog__headerbtn {
      top: 0.2rem !important;
      right: 0.2rem !important;
      font-size: 0.2rem !important;
    }
  }

  // 标签页适配
  .dia_header {
    height: 0.48rem !important;
    position: relative !important;
    left: 0 !important;
    top: 0 !important;
    margin-bottom: 0.24rem !important;
    
    p {
      width: 50% !important;
      font-size: 0.16rem !important;
      line-height: 0.46rem !important;
    }
  }

  // 描述区域适配
  .stakeDes {
    width: 100% !important;
    font-size: 0.13rem !important;
    line-height: 0.18rem !important;
    margin-left: 0 !important;
    margin-bottom: 0.2rem !important;
    flex-direction: column;
    padding: 0.12rem;
    background: #f5f5f5;
    border-radius: 0.08rem;
    
    .img {
      width: 0.36rem !important;
      margin-right: 0 !important;
      margin-bottom: 0.08rem;
    }
  }

  // 表单适配
  .stake-form {
    /deep/ .el-form-item {
      margin-bottom: 0.2rem !important;
      display: flex;
      flex-direction: column;
      
      .el-form-item__label {
        width: 100% !important;
        text-align: left !important;
        padding: 0 0 0.08rem 0 !important;
        font-size: 0.14rem !important;
        line-height: 0.2rem !important;
        margin-bottom: 0.08rem;
      }
      
      .el-form-item__content {
        margin-left: 0 !important;
        width: 100%;
      }
      
      .el-form-item__error {
        font-size: 0.12rem !important;
        padding-top: 0.04rem;
      }
    }
  }

  // 输入框适配
  .amount-input {
    width: 100% !important;
    
    /deep/ .el-input__inner {
      font-size: 0.14rem !important;
      height: 0.44rem !important;
      line-height: 0.44rem !important;
      padding: 0 0.8rem 0 0.12rem !important;
    }
    
    /deep/ .el-input__suffix {
      font-size: 0.12rem !important;
      right: 0.12rem !important;
    }
  }

  // 用户信息适配
  .userinfo {
    gap: 0.08rem;
    flex-wrap: wrap;
    margin-top: 0 !important;
    
    .img {
      width: 0.24rem !important;
      height: 0.24rem !important;
    }
    
    .name {
      font-size: 0.14rem !important;
      line-height: 0.24rem !important;
      word-break: break-all;
    }
    
    .web {
      width: 0.7rem !important;
      height: 0.24rem !important;
      font-size: 0.12rem !important;
      padding-left: 0.24rem !important;
    }
  }

  // 地址显示适配
  .stake-form /deep/ .el-form-item__content {
    word-break: break-all;
    font-size: 0.12rem;
    color: #666;
  }

  // 数字显示适配
  .num {
    font-size: 0.16rem !important;
    word-break: break-all;
  }

  .td-word-sm {
    font-size: 0.14rem !important;
    margin-left: 0.04rem;
  }

  // 按钮适配
  .btn_box {
    margin-top: 0.32rem !important;
    
    .btn {
      width: 100% !important;
      height: 0.48rem !important;
      font-size: 0.16rem !important;
      border-radius: 0.08rem !important;
    }
  }

  // MAX 按钮适配
  .maxbtn {
    font-size: 0.14rem !important;
    margin-left: 0.08rem !important;
    display: inline-block;
    padding: 0.04rem 0.12rem;
    background: #f0f0f0;
    border-radius: 0.04rem;
    vertical-align: middle;
  }

  // 提示信息适配
  .tips {
    font-size: 0.12rem !important;
    line-height: 0.18rem !important;
    margin-top: 0.2rem !important;
    padding: 0.12rem;
    background: #fff9e6;
    border-radius: 0.08rem;
    
    p {
      margin-bottom: 0.06rem !important;
      
      &:first-child {
        float: none !important;
        font-weight: 500;
        margin-bottom: 0.08rem !important;
      }
    }
  }
}
</style>
